/**
 * Information about your app.
 */
export type AppInfo = {
  name: string
  creator: string
}